import axios, { AxiosResponse } from 'axios';
import TagManager from 'react-gtm-module';

export interface IGtmApi {
  updateContainerId(): Promise<AxiosResponse<any>>;
  initGtm(gtmContainerId): Promise<any>;
  gtmEvent(gtmId: string, eventCategory: string, eventAction: string, subscriptionNumber: string, eventValue: string): Promise<any>;
}

export class GtmApi implements IGtmApi {
  async updateContainerId(): Promise<AxiosResponse<any>> {
    return axios.get('gtm/container-id');
  }

  async initGtm(gtmContainerId): Promise<any> {
    return new Promise((resolve, reject) => {
      const tagManagerArgs = {
        gtmId: gtmContainerId,
      };
      TagManager.initialize(tagManagerArgs);
      return resolve(true);
    });
  }

  async gtmEvent(gtmId: string, eventCategory: string, eventAction: string, subscriptionNumber: string, eventValue: string): Promise<any> {
    return new Promise((resolve, reject) => {
      const gtmEvent: any = {
        event: 'santianoDidomiEvent',
        eventCategory,
        eventAction,
        eventLabel: subscriptionNumber === undefined || subscriptionNumber === '' ? "Numero d'adhésion manquant" : subscriptionNumber,
        eventValue,
      };
      if ((window as any).dataLayer) (window as any).dataLayer.push(gtmEvent);
      console.log((window as any).dataLayer);
      return resolve(true);
    });
  }
}
